import { Skeleton } from "antd"
import AttachmentsViewer from "./AttachmentsViewer"
import { useCustomerAttachments } from "./attachmentsQueries"

type Props = {
  customerId: number

}

const CustomerAttachments = ({customerId}: Props) => {
  const attachmentsQuery = useCustomerAttachments(customerId)
  const attachments = attachmentsQuery.data ?? []

  if (attachmentsQuery.isLoading) {
    return <section>
      <Skeleton active />
    </section>
  }

  return <AttachmentsViewer attachments={attachments} customerId={customerId} showFolders={false} showFolderFilter={true} />
}

export default CustomerAttachments